export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4711.451ef5d0.jpg";